import { MotionConfig } from 'framer-motion';
import { type ReactNode } from 'react';

export function MotionRoot({ children }: { children: ReactNode }) {
  return (
    <MotionConfig reducedMotion="user">
      {children}
    </MotionConfig>
  );
}
